export const SITE_URL = "https://radiancerealtors.in";
export const PHONE = "+91 90910 90980";
export const PHONE_HREF = "tel:+919091090980";
export const EMAIL = "contact@radiancerealtors.in";
export const EMAIL_HREF = "mailto:contact@radiancerealtors.in";
export const REGISTERED_ADDRESS =
  "952, 7th Park View, Gaur Yamuna City, Greater Noida - 203201, Uttar Pradesh, India";
export const WHATSAPP_LINK =
  "https://wa.me/919091090980?text=" +
  encodeURIComponent(
    "Hi Radiance Realtors, I'm interested in property in Gaur Yamuna City. Please share the latest available inventory and prices."
  );

const G = "/images/gyc";
export const HERO_SLIDES = [
  { src: `${G}/gyc-16th-parkview-towers.jpg`, caption: "Gaur Yamuna City - 16th Parkview" },
  { src: `${G}/yamuna-expressway-welcome-sign.jpg`, caption: "Yamuna Expressway - the corridor to Greater Noida & Agra" },
  { src: `${G}/gyc-lake-boating.jpg`, caption: "Evening at GYC's landscaped lake" },
  { type: "map", caption: "Seven ways to reach Noida International Airport" },
  { src: `${G}/gyc-central-boulevard.jpg`, caption: "The central boulevard, Gaur Yamuna City" },
];
export const IMG = {
  hero: `${G}/gyc-16th-parkview-towers.jpg`,
  yamunaWelcomeSign: `${G}/yamuna-expressway-welcome-sign.jpg`,
  heroVilla: `${G}/gyc-villa-living.jpg`,
  airport: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=1600&q=80",
  masterplan: `${G}/gyc-entrance-gate.jpg`,
  filmCity: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?auto=format&fit=crop&w=1200&q=80",
  apartment1: `${G}/gyc-tower-facade.jpg`,
  apartment2: `${G}/gyc-flat-interior.jpg`,
  villa1: `${G}/gyc-villa-exterior.jpg`,
  villaBedroom: `${G}/gyc-villa-bedroom.jpg`,
  plots: `${G}/gyc-plotted-sector-roads.jpg`,
  plotsGreens: `${G}/gyc-plotted-sector-greens.jpg`,
  commercial: "https://images.unsplash.com/photo-1555636222-cae831e670b3?auto=format&fit=crop&w=1000&q=80",
  advisor: `${G}/advisor-portrait.jpg`,
  nightCity: `${G}/gyc-aerial-lake.jpg`,
  skyline: `${G}/gyc-lake-boating.jpg`,
  expressway: `${G}/yamuna-expressway.jpg`,
  construction: `${G}/gyc-construction-progress.jpg`,
  gycMasterPlan: `${G}/7pv-master-plan.jpg`,
  sevenPvLayout: `${G}/7pv-layout-plan.jpg`,
  sevenPvLocation: `${G}/7pv-location-map.jpg`,
  sevenPvGate: `${G}/7pv-villa-9.jpg`,
  sevenPvVilla: `${G}/7pv-villa-1.jpg`,
  sevenPvVillaRow: `${G}/7pv-villa-8.jpg`,
  sevenPvPool: `${G}/7pv-villa-3.jpg`,
  sevenPvAerial: `${G}/7pv-villa-5.jpg`,
  sevenPvJogging: `${G}/7pv-villa-4.jpg`,
  aceTerraBanner: `${G}/ace-terra-banner.jpg`,
  aceTerraLobby: `${G}/ace-terra-lobby.jpg`,
  aceTerraPool: `${G}/ace-terra-pool.jpg`,
  aceTerraLandscape: `${G}/ace-terra-landscape.jpg`,
  aceTerraTennis: `${G}/ace-terra-tennis.jpg`,
  aceVerdeBanner: `${G}/ace-verde-banner.jpg`,
  aceVerdeArchitecture: `${G}/ace-verde-architecture.jpg`,
  aceVerdeGate: `${G}/ace-verde-gate.jpg`,
  aceVerdePool: `${G}/ace-verde-pool.jpg`,
  aceAcrevilleBanner: `${G}/ace-acreville-banner.jpg`,
  aceAcrevilleAerial: `${G}/ace-acreville-aerial.jpg`,
  aceAcrevilleGate: `${G}/ace-acreville-gate.jpg`,
  aceAcrevillePark: `${G}/ace-acreville-park.jpg`,
  aceEditBanner: `${G}/ace-edit-banner.jpg`,
  aceYxpHero: `${G}/ace-yxp-hero.jpg`,
  aceYxpGallery1: `${G}/ace-yxp-gallery1.jpg`,
  aceYxpGallery2: `${G}/ace-yxp-gallery2.jpg`,
  purvanchalBanner: `${G}/purvanchal-banner.jpg`,
  purvanchalGallery1: `${G}/purvanchal-gallery1.jpg`,
  purvanchalGallery2: `${G}/purvanchal-gallery2.jpg`,
  purvanchalGallery3: `${G}/purvanchal-gallery3.jpg`,
  eldecoBanner: `${G}/eldeco-banner.jpg`,
  eldecoExterior: `${G}/eldeco-exterior.jpg`,
  sectorDataCentre: "https://images.unsplash.com/photo-1784652852605-6945598f2af3?auto=format&fit=crop&w=1200&q=80",
  sectorApparel: "https://images.unsplash.com/photo-1589793463357-5fb813435467?auto=format&fit=crop&w=1200&q=80",
  sectorWarehouse: "https://images.unsplash.com/photo-1565891741441-64926e441838?auto=format&fit=crop&w=1200&q=80",
};

export const GALLERY = [
  { src: `${G}/gyc-entrance-gate.jpg`, caption: "Gaur Yamuna City entrance, Sector 19" },
  { src: `${G}/gyc-16th-parkview-towers.jpg`, caption: "16th Parkview towers" },
  { src: `${G}/gyc-lake-boating.jpg`, caption: "Yamuna Lake Park, approx. 9 acres" },
  { src: `${G}/gyc-plotted-sector-gate.jpg`, caption: "32nd Parkview plotted enclave" },
  { src: `${G}/gyc-villa-exterior.jpg`, caption: "2nd Parkview villa" },
  { src: `${G}/gyc-aerial-greens.jpg`, caption: "Township greens, aerial" },
  { src: `${G}/gyc-construction-progress.jpg`, caption: "Development in progress" },
  { src: `${G}/gyc-central-boulevard.jpg`, caption: "Central boulevard" },
];

export const SEVENTH_PARKVIEW_GALLERY = [
  { src: `${G}/7pv-villa-9.jpg`, caption: "7th Park View entrance gate" },
  { src: `${G}/7pv-villa-1.jpg`, caption: "Aero Villas elevation" },
  { src: `${G}/7pv-villa-8.jpg`, caption: "Villa row, 7th Park View" },
  { src: `${G}/7pv-villa-5.jpg`, caption: "Aerial view, plotted sectors" },
  { src: `${G}/7pv-villa-3.jpg`, caption: "Clubhouse pool deck" },
  { src: `${G}/7pv-villa-4.jpg`, caption: "Jogging track and green belt" },
];

export const YEIDA_SECTORS = [
  {
    id: "s18",
    sector: "Sector 18",
    tag: "Residential Plots",
    status: "Operational",
    headline: "Greater Noida's most liquid resale plot market",
    plotSummary: "162 - 290 sq.m residential plots",
    rateSummary: "Rs 36,260/sq.m (RPS-10/2026 allotment)",
    plotDetails: [
      ["Latest scheme", "RPS-10/2026 - 973 plots across Sectors 15C, 18 and 24A; draw of lots held 18 June 2026"],
      ["Plot sizes", "162 sq.m (476 plots), 183/184 sq.m (8), 200 sq.m (481), 223 sq.m (6), 290 sq.m (2)"],
      ["Allotment rate", "Rs 36,260 per sq.m; +5% per preferential location (park/green-facing, corner, 18 m+ road), capped"],
      ["Payment", "10% registration deposit with application; lease rent equal to 10% of plot cost at registry"],
      ["Resale band", "Rs 65,000 - 85,000/sq.m in developed pockets (indicative, unverified)"],
    ],
    facts: [
      ["Land use", "Residential plots, YEIDA-notified, individual home construction"],
      ["Established pockets", "Part 1 (1A, 1B, I, J) - possession already granted, registries done"],
      ["2026 scheme activity", "RPS-10/2026 allotted 973 plots across Sectors 15C/18/24A at Rs 36,260/sq.m; an August 2026 proposal earmarked roughly 2,880 further plots of 40 sq.m for Sector 18 alone"],
      ["Resale rates", "Rs 65,000 - 85,000/sq.m in established pockets vs an official circle rate near Rs 35,000/sq.m"],
    ],
    hiddenOpportunity: "Sector 18's mature pockets already have roads, registries and a resident base - the proven, liquid resale market most YEIDA plot buyers only hope to reach years after allotment.",
    image: IMG.plots,
    imageCaption: "Representative image - developed plotted sector",
    disclaimer: "Land-use and scheme figures per YEIDA's notified master plan and 2026 scheme brochures. Always verify current allotment status, registry and construction-timeline compliance before any resale purchase.",
  },
  {
    id: "s28",
    sector: "Sector 28",
    tag: "Medical Device Park + Data Centre Park",
    status: "Under Development",
    headline: "Two named industrial anchors on one YEIDA sector",
    plotSummary: "Industrial plots - up to 4,000 sq.m to 80,000+ sq.m",
    rateSummary: "Rs 4,705 - 7,730/sq.m (Medical Devices Park brochure)",
    plotDetails: [
      ["Scheme", "YEA/IND-MDP(2026)-06 - Medical Devices Park (approx. 350 acres) and Data Centre Park (approx. 100 acres)"],
      ["Plot sizes", "Tiered: up to 4,000 / 4,000-8,000 / 8,000-20,000 / 20,000-40,000 / 40,000-80,000 / above 80,000 sq.m"],
      ["Allotment rate", "Rs 7,730 (up to 4,000 sq.m), 6,585, 5,585, 5,060, 4,895 and Rs 4,705/sq.m (above 80,000 sq.m) - 2025-26 brochure"],
      ["Allotment route", "Draw of lots below 4,000 sq.m; interview-based selection for larger parcels; applications via Nivesh Mitra"],
      ["Eligibility", "GST registration and a detailed project report; end use restricted to med-device / data-centre activity"],
    ],
    facts: [
      ["Designated use", "Medical Devices Park and Data Centre Park (YEIDA-notified industrial zone)"],
      ["Allotment route", "Plots under 4,000 sq.m via draw of lots; larger plots via interview-based selection"],
      ["Eligibility", "GST registration and a project report are typically required for park-specific plots"],
      ["Proximity", "Within YEIDA's core industrial belt, close to Noida International Airport"],
    ],
    hiddenOpportunity: "A dedicated data-centre and med-device manufacturing cluster this close to an international airport is the kind of infrastructure that quietly lifts jobs, rents and footfall in nearby residential sectors years before most buyers notice.",
    image: IMG.sectorDataCentre,
    imageCaption: "Representative image - data centre infrastructure",
    disclaimer: "Industrial land-use classification per YEIDA's published property portal. Allotment is scheme-specific and interview/draw based - verify live scheme status on yamunaexpresswayauthority.com before applying.",
  },
  {
    id: "s29",
    sector: "Sector 29",
    tag: "Apparel & Handicraft Park",
    status: "Under Development",
    headline: "An export and MSME hub feeding the airport-led economy",
    plotSummary: "MSME & apparel plots - 300 sq.m to 25,000+ sq.m",
    rateSummary: "E-auction base from Rs 15,670/sq.m (up to 4,000 sq.m)",
    plotDetails: [
      ["Scheme", "Apparel Park, Toy Park and Handicraft / MSME industrial plot schemes - allotted through e-auction"],
      ["Plot sizes", "Small MSME units of roughly 300-500 sq.m through to large parcels above 25,000 sq.m"],
      ["Base rate", "E-auction base price from Rs 15,670 per sq.m for plots up to 4,000 sq.m (2026 schemes)"],
      ["Allotment route", "Online e-auction / draw via YEIDA's industrial property portal and Nivesh Mitra"],
      ["Transit", "Three planned Pod Taxi (PRT) stops - Sector 29, Handicraft Park and MSME Park"],
    ],
    facts: [
      ["Designated use", "Apparel Park, Handicraft/Furniture Park and general MSME industrial units"],
      ["Allotment route", "Draw of lots for smaller plots; interview-based for larger industrial parcels"],
      ["Strategic fit", "Positioned to serve export cargo once the airport's freight terminal scales up"],
    ],
    hiddenOpportunity: "Apparel and handicraft export hubs create dense, steady employment - the kind of demand base that supports rental and small-format retail long before headline residential prices move.",
    image: IMG.sectorApparel,
    imageCaption: "Representative image - apparel/MSME manufacturing",
    disclaimer: "Land-use classification per YEIDA's industrial property portal; verify current scheme, eligibility and rates directly with the authority.",
  },
  {
    id: "s30",
    sector: "Sector 30",
    tag: "Planned - Grid-Iron Zone",
    status: "Proposed",
    headline: "Part of YEIDA's broader development grid; no major scheme live yet",
    plotSummary: "No plot scheme live yet",
    rateSummary: "Rates not yet notified by YEIDA",
    plotDetails: [
      ["Scheme", "None live at research date - the sector sits inside the YEIDA Master Plan 2041 grid"],
      ["Plot sizes", "To be defined in the sector's Final Layout plan once notified"],
      ["Rate", "Not yet notified - published by YEIDA with the first scheme brochure"],
      ["What to track", "Land-use notification, Final Layout PDF on the YEIDA portal and the first scheme launch"],
    ],
    facts: [
      ["Master plan status", "Included within YEIDA's notified grid-iron layout for the region"],
      ["Active schemes", "None specifically identified for this sector at the time of research, unlike Sectors 18, 28, 29 or 32"],
      ["What to watch", "Land-use notification and the sector's first formal scheme launch"],
    ],
    hiddenOpportunity: "Early-stage sectors like this carry the highest uncertainty but also the lowest entry point - patient, well-advised capital sometimes enters exactly here, well before infrastructure and demand catch up.",
    image: IMG.expressway,
    imageCaption: "Representative image - Yamuna Expressway corridor",
    disclaimer: "No active YEIDA scheme was confirmed for this sector at the time of research. Treat any resale or land offer here with extra diligence and verify directly with YEIDA.",
  },
  {
    id: "s31",
    sector: "Sector 31",
    tag: "Planned - Grid-Iron Zone",
    status: "Proposed",
    headline: "Adjacent planned sector, similarly early-stage",
    plotSummary: "No plot scheme live yet",
    rateSummary: "Rates not yet notified by YEIDA",
    plotDetails: [
      ["Scheme", "None live at research date - the sector sits inside the YEIDA Master Plan 2041 grid"],
      ["Plot sizes", "To be defined in the sector's Final Layout plan once notified"],
      ["Rate", "Not yet notified - published by YEIDA with the first scheme brochure"],
      ["What to track", "Land-use notification, Final Layout PDF on the YEIDA portal and the first scheme launch"],
    ],
    facts: [
      ["Master plan status", "Included within YEIDA's notified grid-iron layout for the region"],
      ["Active schemes", "None specifically identified for this sector at the time of research"],
      ["What to watch", "Land-use notification and the sector's first formal scheme launch"],
    ],
    hiddenOpportunity: "As with Sector 30, the opportunity here is optionality - being on our alert list the moment YEIDA notifies a scheme, rather than reacting after the fact.",
    image: IMG.expressway,
    imageCaption: "Representative image - Yamuna Expressway corridor",
    disclaimer: "No active YEIDA scheme was confirmed for this sector at the time of research. Treat any resale or land offer here with extra diligence and verify directly with YEIDA.",
  },
  {
    id: "s32",
    sector: "Sector 32",
    tag: "Industrial - Manufacturing & Warehousing",
    status: "Under Development",
    headline: "Core industrial belt closest to the airport",
    plotSummary: "Industrial / warehousing plots - 300 sq.m to 25,000+ sq.m",
    rateSummary: "Tiered by plot size per YEIDA industrial brochure",
    plotDetails: [
      ["Scheme", "YEA/IND8000(2025-26)-14 general industrial plots and successor schemes"],
      ["Plot sizes", "Flexible - approx. 300-500 sq.m MSME units up to footprints above 25,000 sq.m"],
      ["Allotment rate", "Tiered by plot size as per each scheme brochure - larger plots attract lower per-sq.m rates"],
      ["Allotment route", "Draw of lots below 4,000 sq.m; interview for larger parcels; applications via Nivesh Mitra"],
      ["Transit", "Namo Bharat RRTS alignment runs through the YEIDA sectors to the airport's underground station"],
    ],
    facts: [
      ["Designated use", "General manufacturing, warehousing and MSME industrial units"],
      ["Proximity", "Notably close to Noida International Airport - a direct logistics advantage"],
      ["Allotment route", "Scheme-based via YEIDA's industrial property portal, draw or interview depending on size"],
    ],
    hiddenOpportunity: "Warehousing demand tends to arrive quietly, ahead of residential price growth, the moment an airport with cargo capacity goes live - Sector 32 is positioned to capture exactly that shift first.",
    image: IMG.sectorWarehouse,
    imageCaption: "Representative image - warehousing & logistics",
    disclaimer: "Industrial land-use classification per YEIDA's published property portal; verify live scheme status, rates and eligibility directly with the authority.",
  },
];

export const ACE_PROJECTS = [
  {
    id: "ace-terra",
    name: "Ace Terra",
    sector: "Sector 22D, Yamuna Expressway",
    rera: "UPRERAPRJ683816",
    category: "Residential",
    config: "3 & 4 BHK apartments",
    scale: "12 towers of 25 storeys",
    status: "Under Development",
    highlights: ["Club Spade clubhouse", "Abundant green spaces & water features", "3 & 4 BHK with spacious decks"],
    images: [IMG.aceTerraBanner, IMG.aceTerraPool, IMG.aceTerraLandscape, IMG.aceTerraTennis],
  },
  {
    id: "ace-yxp",
    name: "Ace YXP",
    sector: "Sector 22D, Yamuna Expressway",
    rera: "UPRERAPRJ397607",
    category: "Commercial",
    config: "High-street retail, studio apartments & multiplex",
    scale: "Approx. 16,004 sq.m, Art Deco-inspired lifestyle centre",
    status: "Under Development",
    highlights: ["Food court & gaming zones", "Premier multiplex & banquet hall", "Tentative retail price ~Rs 24,995-25,995/sq.ft"],
    images: [IMG.aceYxpHero, IMG.aceYxpGallery1, IMG.aceYxpGallery2],
  },
  {
    id: "ace-verde",
    name: "Ace Verde",
    sector: "Sector 22A, Yamuna Expressway",
    rera: "UPRERAPRJ913692/03/2025",
    category: "Residential",
    config: "Studio apartments & 3 / 3.5 BHK residences",
    scale: "Neoclassical architecture, two clubhouses",
    status: "Under Development",
    highlights: ["Swimming pool & padel court", "Fine-dine restaurant", "Gym / Pilates / Zumba studio"],
    images: [IMG.aceVerdeBanner, IMG.aceVerdeArchitecture, IMG.aceVerdeGate, IMG.aceVerdePool],
  },
  {
    id: "ace-acreville",
    name: "Ace Acreville",
    sector: "Sector 22A, Yamuna Expressway",
    rera: "UPRERAPRJ248777/03/2025",
    category: "Plots",
    config: "200, 300 & 500 sq.yd residential plots",
    scale: "100-acre gated plotted township",
    status: "Under Development",
    highlights: ["Rooftop multi-cuisine restaurant", "Golf cart station", "Committed possession March 2026"],
    images: [IMG.aceAcrevilleBanner, IMG.aceAcrevilleAerial, IMG.aceAcrevilleGate, IMG.aceAcrevillePark],
  },
  {
    id: "ace-edit",
    name: "Ace Edit",
    sector: "Sector 22D, Yamuna Expressway",
    rera: "UPRERAPRJ467686/09/2025",
    category: "Mixed-Use",
    config: "Retail, F&B street & studio suites",
    scale: "Approx. 3.4 acres (13,770.97 sq.m)",
    status: "Under Development",
    highlights: ["Terrace swimming pool", "Expansive clubhouse", "Al fresco dining street"],
    images: [IMG.aceEditBanner],
  },
];

export const PURVANCHAL_PROJECTS = [
  {
    id: "purvanchal-sunbliss",
    name: "Purvanchal Sunbliss",
    developer: "Purvanchal Projects Pvt. Ltd.",
    sector: "Sector 22D, Yamuna Expressway",
    rera: "UPRERAPRJ746863/04/2025",
    category: "Residential",
    config: "1, 3 & 4 BHK apartments (725 - 3,695 sq.ft)",
    scale: "7 towers of 25 floors, 1,112 units, ~10.5 acres",
    status: "Under Development",
    possession: "January 2030 (per developer)",
    highlights: ["Piano-theme, opera-style clubhouse", "Temperature-controlled indoor pool", "Badminton, tennis & cycling track"],
    images: [IMG.purvanchalBanner, IMG.purvanchalGallery1, IMG.purvanchalGallery2, IMG.purvanchalGallery3],
  },
  {
    id: "eldeco-whispers",
    name: "Eldeco Whispers of Wonder",
    developer: "Eldeco Sohna Projects Ltd.",
    sector: "Sector 22D, Yamuna Expressway",
    rera: "UPRERAPRJ752382/09/2025",
    category: "Residential",
    config: "3 & 4 BHK apartments (871 - 1,819 sq.ft carpet)",
    scale: "3 towers, 574 units, 5 acres",
    status: "Under Development",
    possession: "July 2030 (per developer)",
    highlights: ["Kids' splash pool", "Indoor squash & badminton courts", "Rs 1.57 Cr - Rs 3.20 Cr price band"],
    images: [IMG.eldecoBanner, IMG.eldecoExterior],
  },
];

export const YEIDA_SCHEME = {
  code: "RPS-10/2026",
  status: "Draw Completed",
  stats: [
    { value: "973", label: "Residential plots" },
    { value: "₹36,260", label: "Per sq.m allotment rate" },
    { value: "162–290", label: "Plot sizes (sq.m)" },
    { value: "1,10,034", label: "Applications received" },
  ],
  facts: [
    ["Sectors", "15C, 18 and 24A — all within the Noida International Airport influence zone"],
    ["Tenure", "90-year leasehold from YEIDA"],
    ["Registration", "10% of plot premium at application; balance within 60 days of allotment"],
    ["PLC", "5% for corner, park-facing, green-belt-facing or 18 m+ road-facing plots"],
    ["Draw", "Computerised lottery, 18 June 2026, India Expo Centre & Mart, Greater Noida"],
    ["Oversubscription", "Approx. 113 applicants per plot"],
  ],
};

export const YEIDA_HISTORY = [
  { year: "2025", title: "Pocket 9B, Sector 18", detail: "276 plots at ₹35,000 / sq.m", status: "Allotted" },
  { year: "2025", title: "Second 2025 scheme", detail: "451 plots at ₹25,900 / sq.m", status: "Allotted" },
  { year: "2026", title: "RPS-10/2026 — Sectors 15C, 18, 24A", detail: "973 plots at ₹36,260 / sq.m", status: "Allotted" },
  { year: "Next", title: "Sectors 17, 18 & 20", detail: "Approx. 3,800 plots of 40 sq.m proposed", status: "Proposed" },
];

export const YEIDA_ELIGIBILITY = [
  "Applicant must be 18+ and an Indian citizen (NRIs permitted unless barred by law)",
  "One plot per applicant; prior YEIDA residential allottees are ineligible",
  "Joint applications only with immediate family, with relationship proof",
  "HUFs and companies are not eligible under the residential scheme",
  "Applications are accepted only online at yamunaexpresswayauthority.com",
];

export const YEIDA_VS_GYC = [
  ["Route to ownership", "Online scheme + computerised draw", "Direct purchase from developer or resale"],
  ["Availability", "Only when a scheme is open (~1 in 113 odds in 2026)", "On demand, subject to inventory"],
  ["Tenure", "90-year leasehold", "Verify per project documents"],
  ["Price discovery", "Fixed authority rate per sq.m", "Market-driven, negotiable"],
  ["Infrastructure", "Sector development follows allotment", "Roads, greens and utilities largely in place"],
  ["Advisory role", "Scheme alerts, application & post-allotment guidance", "Selection, verification, negotiation"],
];

export const PROPERTIES = [
  { id: "p1", project: "Gaur 16th Parkview", category: "Apartment", config: "3 BHK", size: "1,675 sq.ft", price: "Rs 1.05 Cr", priceValue: 10500000, priceOnRequest: false, status: "Under Development", possession: "2027 (Expected)", floor: "12 of 24", facing: "Park Facing", rera: "UPRERAPRJ - verify on UP RERA portal", highlights: ["Park-facing tower", "GYC internal township amenities", "Near proposed commercial hub"], listing: "New", purpose: ["End Use", "Investment"], image: IMG.apartment1 },
  { id: "p2", project: "Gaur 32nd Parkview", category: "Apartment", config: "2 BHK", size: "1,150 sq.ft", price: "Rs 68 L", priceValue: 6800000, priceOnRequest: false, status: "Under Development", possession: "2027 (Expected)", floor: "8 of 22", facing: "East", rera: "UPRERAPRJ - verify on UP RERA portal", highlights: ["Entry-level GYC apartment", "Efficient layout", "Lift + power backup"], listing: "New", purpose: ["End Use", "Investment"], image: IMG.apartment2 },
  { id: "p3", project: "Gaur Runway Suites", category: "Studio", config: "Studio", size: "595 sq.ft", price: "Rs 42 L", priceValue: 4200000, priceOnRequest: false, status: "Under Development", possession: "2026 (Expected)", floor: "10 of 14", facing: "Expressway Side", rera: "UPRERAPRJ - verify on UP RERA portal", highlights: ["Compact investment format", "Aimed at airport-led rental demand", "Managed-suite concept"], listing: "New", purpose: ["Investment"], image: IMG.apartment1 },
  { id: "p4", project: "Gaur Aero Suites", category: "Studio", config: "Studio", size: "620 sq.ft", price: "Rs 45 L", priceValue: 4500000, priceOnRequest: false, status: "Under Development", possession: "2026 (Expected)", floor: "6 of 14", facing: "North", rera: "UPRERAPRJ - verify on UP RERA portal", highlights: ["Serviced-studio concept", "Target: airport workforce demand", "Low ticket entry"], listing: "New", purpose: ["Investment"], image: IMG.apartment2 },
  { id: "p5", project: "Waterfront Plots", category: "Plot", config: "Residential Plot", size: "300 sq.yd", price: "Rs 2.4 Cr", priceValue: 24000000, priceOnRequest: false, status: "Operational", possession: "Ready to Register", floor: "-", facing: "Lake Facing", rera: "Plots under YEIDA / GYC approvals - verify", highlights: ["Scarce waterfront positioning", "Gated plotted enclave", "Long-term land holding"], listing: "New", purpose: ["Investment", "End Use"], image: IMG.plots },
  { id: "p6", project: "GYC Residential Plot - Sector 19", category: "Plot", config: "Residential Plot", size: "162 sq.yd", price: "Rs 1.1 Cr", priceValue: 11000000, priceOnRequest: false, status: "Operational", possession: "Ready to Register", floor: "-", facing: "East", rera: "Verify title + approvals independently", highlights: ["Developed plotted sector", "Internal roads in place", "Resale market depth"], listing: "Resale", purpose: ["Investment"], image: IMG.plotsGreens },
  { id: "p7", project: "Lakeshore Villas", category: "Villa", config: "4 BHK Villa", size: "3,200 sq.ft", price: "Rs 3.9 Cr", priceValue: 39000000, priceOnRequest: false, status: "Under Development", possession: "2026 (Expected)", floor: "G+1", facing: "Lake Facing", rera: "UPRERAPRJ - verify on UP RERA portal", highlights: ["Limited villa inventory", "Private greens", "Premium buyer profile"], listing: "New", purpose: ["End Use"], image: IMG.villa1 },
  { id: "p8", project: "Victorian Villas", category: "Villa", config: "5 BHK Villa", size: "4,100 sq.ft", price: "Price on Request", priceValue: 0, priceOnRequest: true, status: "Under Development", possession: "2027 (Expected)", floor: "G+2", facing: "Park Facing", rera: "UPRERAPRJ - verify on UP RERA portal", highlights: ["Heritage-inspired facade", "Large private plots", "Top-tier GYC living"], listing: "New", purpose: ["End Use"], image: IMG.heroVilla },
  { id: "p9", project: "Shri Radhey Kunj", category: "Villa", config: "3 BHK Villa", size: "2,150 sq.ft", price: "Rs 1.8 Cr", priceValue: 18000000, priceOnRequest: false, status: "Operational", possession: "Ready to Move", floor: "G+1", facing: "East", rera: "Verify on UP RERA portal", highlights: ["Completed villa cluster", "Immediate possession", "End-user community formed"], listing: "New", purpose: ["End Use"], image: IMG.villaBedroom },
  { id: "p10", project: "Aerocity Yamuna - Retail", category: "Commercial", config: "Retail Shop", size: "300 sq.ft", price: "Rs 85 L", priceValue: 8500000, priceOnRequest: false, status: "Announced", possession: "On Development", floor: "Ground", facing: "High Street", rera: "UPRERAPRJ - verify on UP RERA portal", highlights: ["Gaur commercial development", "Airport-corridor footfall thesis", "High-street retail format"], listing: "New", purpose: ["Investment"], image: IMG.commercial },
  { id: "p11", project: "GYC City Galleria - Shop", category: "Commercial", config: "Retail Shop", size: "250 sq.ft", price: "Rs 72 L", priceValue: 7200000, priceOnRequest: false, status: "Under Development", possession: "2026 (Expected)", floor: "Ground", facing: "Main Atrium", rera: "UPRERAPRJ - verify on UP RERA portal", highlights: ["Township retail catchment", "Daily-needs footfall", "Compact ticket size"], listing: "New", purpose: ["Investment"], image: IMG.commercial },
  { id: "p12", project: "16th Parkview - Verified Resale", category: "Resale", config: "2 BHK", size: "1,050 sq.ft", price: "Rs 58 L", priceValue: 5800000, priceOnRequest: false, status: "Operational", possession: "Ready to Move", floor: "5 of 24", facing: "West", rera: "Resale - verify chain of title", highlights: ["Verified resale desk listing", "Below new-inventory ticket", "Immediate possession"], listing: "Resale", purpose: ["End Use", "Investment"], image: IMG.apartment2 },
];

export const PROJECTS = [
  { name: "Gaur 16th Parkview", type: "Apartments", location: "Gaur Yamuna City", config: "2 / 3 BHK", price: "Rs 58 L onwards", status: "Under Development", image: IMG.apartment1 },
  { name: "Gaur 32nd Parkview", type: "Apartments", location: "Gaur Yamuna City", config: "2 / 3 BHK", price: "Rs 68 L onwards", status: "Under Development", image: IMG.apartment2 },
  { name: "Waterfront Plots", type: "Residential Plots", location: "Gaur Yamuna City", config: "162 - 500 sq.yd", price: "Rs 1.1 Cr onwards", status: "Operational", image: IMG.plots },
  { name: "Lakeshore Villas", type: "Villas", location: "Gaur Yamuna City", config: "4 BHK", price: "Rs 3.9 Cr onwards", status: "Under Development", image: IMG.villa1 },
  { name: "Shri Radhey Kunj", type: "Villas", location: "Gaur Yamuna City", config: "3 BHK", price: "Rs 1.8 Cr onwards", status: "Operational", image: IMG.villaBedroom },
  { name: "Victorian Villas", type: "Villas", location: "Gaur Yamuna City", config: "5 BHK", price: "Price on Request", status: "Under Development", image: IMG.heroVilla },
  { name: "Gaur Runway Suites", type: "Studio", location: "Gaur Yamuna City", config: "Studio Suites", price: "Rs 42 L onwards", status: "Under Development", image: IMG.apartment1 },
  { name: "Gaur Aero Suites", type: "Studio", location: "Gaur Yamuna City", config: "Studio Suites", price: "Rs 45 L onwards", status: "Under Development", image: IMG.apartment2 },
  { name: "Aerocity Yamuna", type: "Commercial", location: "Yamuna Expressway", config: "Retail / Commercial", price: "Rs 85 L onwards", status: "Announced", image: IMG.commercial },
];

export const TIMELINE = [
  { era: "THEN", items: [
    { title: "Yamuna Expressway", detail: "165 km access-controlled expressway connecting Greater Noida to Agra.", status: "Operational" },
    { title: "Early Yamuna Development", detail: "YEIDA notified development area; first plotted sectors take shape.", status: "Operational" },
    { title: "Gaur Yamuna City", detail: "Integrated township launched on the expressway's eastern bank.", status: "Operational" },
  ]},
  { era: "NOW", items: [
    { title: "Noida International Airport", detail: "Phase 1 operational at Jewar (DXN) - commercial flights since 15 June 2026; international routes slated for later in 2026.", status: "Operational" },
    { title: "Residential Expansion", detail: "GYC towers, villas and Sector 22D projects under active construction.", status: "Under Development" },
    { title: "Infrastructure Build-out", detail: "Roads, utilities and expressway interchanges expanding across YEIDA.", status: "Under Development" },
  ]},
  { era: "NEXT", items: [
    { title: "International Film City", detail: "Proposed film production ecosystem in YEIDA's Sector 21.", status: "Announced" },
    { title: "Industrial & Technology Parks", detail: "Medical Device Park, data centres and electronics ecosystem announced along the corridor.", status: "Announced" },
    { title: "Aerotropolis Commercial Expansion", detail: "Aerocity-style hospitality, retail and office districts proposed around the airport.", status: "Proposed" },
  ]},
];

export const HIDDEN_CARDS = [
  { title: "Aviation", subtitle: "Noida International Airport", desc: "Greenfield international airport at Jewar - Phase 1 operational since June 2026.", status: "Operational" },
  { title: "Entertainment", subtitle: "International Film City", desc: "Proposed film production and entertainment district.", status: "Announced" },
  { title: "Industry", subtitle: "Medical Device Park", desc: "Dedicated manufacturing ecosystem announced in YEIDA.", status: "Announced" },
  { title: "Technology", subtitle: "Data Centre Ecosystem", desc: "Hyperscale data-centre investment announced for the region.", status: "Announced" },
  { title: "Electronics", subtitle: "Semiconductor Ecosystem", desc: "Electronics and semiconductor proposals along the corridor.", status: "Proposed" },
  { title: "Logistics", subtitle: "Warehousing & Freight", desc: "Multi-modal logistics parks forming around the airport zone.", status: "Under Development" },
  { title: "Sports", subtitle: "Buddh International Circuit", desc: "Operational F1-grade circuit anchoring a sports ecosystem.", status: "Operational" },
  { title: "Commercial", subtitle: "Retail & Business Districts", desc: "Aerocity Yamuna and corridor retail development.", status: "Announced" },
  { title: "Residential", subtitle: "Gaur Yamuna City", desc: "Operational integrated township at the corridor's heart.", status: "Operational" },
];

export const PROFILES = [
  { name: "End User", assets: ["Apartments", "Villas", "Independent Floors"], focus: "Living, lifestyle and long-term residence inside a forming township.", num: "01" },
  { name: "Land Investor", assets: ["Residential Plots"], focus: "Land ownership, long-term holding and location strategy along the corridor.", num: "02" },
  { name: "Commercial Investor", assets: ["Shops", "Commercial Plots"], focus: "Business activity, footfall, local ecosystem and rental potential.", num: "03" },
  { name: "Early-Growth Investor", assets: ["Selected Emerging Inventory"], focus: "Development stage, entry pricing and multi-year holding periods.", num: "04" },
  { name: "Premium Buyer", assets: ["Waterfront Plots", "Premium Villas", "Premium Apartments"], focus: "Lifestyle, scarcity and irreplaceable location within GYC.", num: "05" },
];

export const INSIGHTS = [
  { title: "Why the Airport Changes the Yamuna Corridor", tag: "Corridor Research", read: "6 min" },
  { title: "Gaur Yamuna City vs Sector 22D", tag: "Location Analysis", read: "8 min" },
  { title: "Apartment vs Plot: Which Fits Your Strategy?", tag: "Investment Framework", read: "5 min" },
  { title: "The Film City Opportunity", tag: "Demand Drivers", read: "4 min" },
  { title: "Understanding Airport-City Development", tag: "Urban Economics", read: "7 min" },
  { title: "Commercial Property Around Gaur Yamuna City", tag: "Commercial Research", read: "6 min" },
  { title: "Future Infrastructure Around YEIDA", tag: "Infrastructure Watch", read: "5 min" },
  { title: "Things to Check Before Buying in Yamuna City", tag: "Buyer Checklist", read: "9 min" },
];

export const CORRIDOR_NODES = [
  { id: "gyc", label: "Gaur Yamuna City", x: 500, y: 300, center: true, status: "Operational", desc: "Integrated township: apartments, plots, villas, commercial and retail." },
  { id: "airport", label: "Noida International Airport", x: 180, y: 120, status: "Operational", desc: "Greenfield international airport at Jewar (DXN) - Phase 1 operational, commercial flights since June 2026." },
  { id: "yeida", label: "YEIDA Sectors 15C / 18 / 24A", x: 330, y: 380, status: "Under Development", desc: "Authority plotted sectors - 973 plots allotted via RPS-10/2026 draw." },
  { id: "film", label: "Film City", x: 800, y: 140, status: "Announced", desc: "Proposed International Film City in YEIDA Sector 21." },
  { id: "s22d", label: "Sector 22D", x: 760, y: 330, status: "Under Development", desc: "High-activity residential sector with multiple major developers." },
  { id: "s22e", label: "Sector 22E", x: 820, y: 430, status: "Under Development", desc: "Emerging residential and institutional sector adjacent to 22D." },
  { id: "medical", label: "Medical Device Park", x: 300, y: 480, status: "Announced", desc: "Announced dedicated medical-device manufacturing park." },
  { id: "datacenter", label: "Data Centre Park", x: 120, y: 340, status: "Announced", desc: "Announced data-centre investments in the YEIDA region." },
  { id: "logistics", label: "Logistics Hub", x: 220, y: 220, status: "Under Development", desc: "Warehousing and freight parks forming around the airport zone." },
  { id: "sports", label: "Buddh Int. Circuit", x: 660, y: 510, status: "Operational", desc: "Operational Formula 1-grade circuit and sports ecosystem." },
  { id: "expressway", label: "Yamuna Expressway", x: 400, y: 120, status: "Operational", desc: "165 km access-controlled corridor: Greater Noida to Agra." },
  { id: "eperipheral", label: "Eastern Peripheral Expy", x: 100, y: 460, status: "Operational", desc: "Operational orbital expressway linking NCR's eastern flank." },
  { id: "greaternoida", label: "Greater Noida", x: 620, y: 90, status: "Operational", desc: "Established NCR city anchoring the corridor's northern end." },
];

export const CONNECTIVITY = [
  { label: "Noida International Airport", x: 170, y: 150, note: "Via Yamuna Expressway" },
  { label: "Jewar", x: 140, y: 260, note: "Airport city zone" },
  { label: "Greater Noida", x: 620, y: 120, note: "Via Yamuna Expressway" },
  { label: "Noida", x: 800, y: 200, note: "Via Expressway + Noida link roads" },
  { label: "Delhi", x: 860, y: 90, note: "Via Noida / DND corridor" },
  { label: "Eastern Peripheral Expy", x: 830, y: 420, note: "Orbital NCR connection" },
  { label: "Mathura", x: 300, y: 520, note: "South on Yamuna Expressway" },
  { label: "Agra", x: 480, y: 560, note: "Expressway southern terminus" },
];

export const NIA_HUB = { x: 640, y: 450 };

export const NIA_NODES = [
  { label: "Delhi (Mayur Vihar)", x: 120, y: 80 },
  { label: "Botanical Garden", x: 240, y: 130 },
  { label: "Okhla Barrage", x: 190, y: 200 },
  { label: "Noida Sec 142", x: 330, y: 210 },
  { label: "Ghaziabad", x: 400, y: 50 },
  { label: "Greater Noida West", x: 440, y: 125 },
  { label: "Bodaki MMTH", x: 520, y: 190 },
  { label: "Pari Chowk", x: 430, y: 290 },
  { label: "Ecotech VI", x: 570, y: 260 },
  { label: "GYC Sector 19", x: 500, y: 370 },
  { label: "Film City Sec 21", x: 590, y: 340 },
  { label: "Sector 29", x: 615, y: 395, anchor: "end" },
  { label: "ISBT Sector 23C", x: 740, y: 360 },
  { label: "Chola Station", x: 850, y: 440 },
  { label: "Faridabad / Ballabhgarh", x: 170, y: 470 },
  { label: "EPE Interchange", x: 380, y: 560 },
  { label: "Mathura / Agra", x: 780, y: 580 },
];

export const NIA_TRANSPORT = [
  {
    id: "expressway",
    mode: "Direct Expressway",
    icon: "Route",
    status: "Under Development",
    stat: "3 new road links",
    headline: "Delhi, Faridabad and the EPE - each getting a direct high-speed road to NIA",
    facts: [
      "Yamuna Pushta elevated expressway: ~50 km, 8-lane NHAI bypass from Okhla Barrage (Noida Sec 94) along the Yamuna to YEIDA Sector 23C, 3-5 km from the airport - DPR in preparation",
      "Faridabad-Jewar Greenfield Expressway: 31.42 km, 6-lane, links Ballabhgarh (Delhi-Mumbai Expressway) to Dayanatpur near NIA - targeted completion May 2027",
      "EPE-Yamuna Expressway cloverleaf at Jaganpur-Afzalpur - 75% complete, targeted October 2026",
    ],
    benefit: "A GYC resident will be able to reach Delhi without touching the Noida Expressway - and airport traffic from Haryana, Meerut and Palwal will bypass Pari Chowk entirely.",
    stops: ["Okhla Barrage", "Yamuna Pushta", "Sector 23C", "NIA"],
    paths: [
      [[190, 200], [300, 300], [520, 420], [640, 450]],
      [[170, 470], [400, 470], [640, 450]],
      [[380, 560], [520, 510], [640, 450]],
    ],
  },
  {
    id: "rrts",
    mode: "Namo Bharat RRTS",
    icon: "TrainFront",
    status: "Announced",
    stat: "72.5 km · 23 stations",
    headline: "Ghaziabad to Jewar in 35-50 minutes on shared RRTS + metro tracks",
    facts: [
      "NCRTC preliminary DPR complete - Rs 20,640 crore, 21 elevated stations plus an underground terminus under NIA Terminal-1",
      "Ghaziabad to Ecotech VI (39.4 km) via Siddharth Vihar, Greater Noida West, Knowledge Park V; Ecotech VI to NIA (33.1 km) via Dankaur and the YEIDA sectors",
      "11 Namo Bharat express stations, 18 local-metro stations, 7 common interchanges; interchange with Delhi-Meerut line at Ghaziabad",
    ],
    benefit: "The YEIDA sectors between Ecotech VI and the airport - GYC's neighbourhood - sit directly on the alignment. Station-adjacent land is where corridor values typically move first.",
    stops: ["Ghaziabad", "GN West", "Knowledge Park V", "Ecotech VI", "YEIDA Sectors", "NIA"],
    paths: [[[400, 50], [440, 125], [520, 190], [570, 260], [610, 360], [640, 450]]],
  },
  {
    id: "metro",
    mode: "Metro (Aqua Line)",
    icon: "TramFront",
    status: "Under Development",
    stat: "2 corridors under L&T",
    headline: "Aqua Line extensions knit Delhi Metro to the Bodaki hub and onward to the RRTS",
    facts: [
      "Botanical Garden to Sector 142 (11.56 km elevated) - contract awarded to L&T, ~3-year build; links Blue and Magenta lines to the Aqua Line",
      "Greater Noida Depot to Bodaki (2.6 km) - connects the Aqua Line to the Bodaki Multi-Modal Transport Hub (rail terminal + ISBT)",
      "Greater Noida West corridor (Sector 51 to Kisan Chowk, ~7.5 km) - PIB approved, awaiting Cabinet nod",
    ],
    benefit: "Metro brings the whole of Noida and Delhi's Blue/Magenta network within one or two interchanges of the airport-bound RRTS - the everyday commute story for GYC's future residents.",
    stops: ["Botanical Garden", "Sector 142", "Pari Chowk", "Depot", "Bodaki MMTH"],
    paths: [[[240, 130], [330, 210], [430, 290], [520, 190]]],
    dashed: true,
  },
  {
    id: "pod",
    mode: "Pod Taxi (PRT)",
    icon: "CableCar",
    status: "Proposed",
    stat: "14.6 km · 12 stations",
    headline: "India's first driverless pod network - Film City to the airport in about 8 minutes",
    facts: [
      "14.6 km Personal Rapid Transit line from Film City (Sector 21) to NIA with 12 stations including Sector 29, Handicraft Park and MSME Park",
      "Estimated Rs 810 crore; ~146 pods initially (22 passengers, 40 km/h), scaling to ~945; ~30,000 daily riders projected",
      "Feasibility being re-evaluated by YEIDA's PPP committee after early global tenders drew limited interest; possible extension towards Pari Chowk",
    ],
    benefit: "A quiet last-mile network threading the Film City, MSME parks and the airport - the kind of amenity that makes Sector 21/22/29 addresses feel like an aerotropolis rather than a suburb.",
    stops: ["Film City Sec 21", "Sector 22", "Sector 29", "Handicraft Park", "MSME Park", "NIA"],
    paths: [[[590, 340], [615, 395], [640, 450]]],
    dashed: true,
  },
  {
    id: "bullet",
    mode: "Bullet Train",
    icon: "Zap",
    status: "Announced",
    stat: "Delhi-Varanasi HSR",
    headline: "An underground high-speed rail station beneath Noida International Airport",
    facts: [
      "NHSRCL has finalised the Delhi-Varanasi alignment (~865 km) with three Noida-region stations: Mayur Vihar, Noida Sector 96 and an underground station at Jewar Airport",
      "Corridor to serve Delhi, Noida, Mathura, Agra, Lucknow, Ayodhya, Prayagraj and Varanasi at up to 350 km/h",
      "UP Government has also approved a DPR for a Delhi-NIA RRTS spur targeting a ~21-minute journey, forwarded to MoHUA",
    ],
    benefit: "Very few Indian townships will sit ten minutes from a bullet-train station. When it lands, GYC's addressable market stretches from Delhi to Varanasi.",
    stops: ["Delhi (Mayur Vihar)", "Noida Sec 96", "NIA (underground)", "Mathura", "Agra"],
    paths: [[[120, 80], [240, 130], [640, 450], [780, 580]]],
    dashed: true,
  },
  {
    id: "rail",
    mode: "Railway Station",
    icon: "Train",
    status: "Proposed",
    stat: "Chola + Bodaki terminals",
    headline: "Two rail gateways - Chola on the Delhi-Howrah line and the Bodaki passenger terminal",
    facts: [
      "Chola Railway Station (Bulandshahr side, ~15 km from NIA) proposed for redevelopment into a multimodal hub with Shatabdi / Rajdhani stoppages - Jewar MLA has formally petitioned the Railway Ministry",
      "Bodaki Multi-Modal Transport Hub near Greater Noida to host a new railway passenger terminal, ISBT and the extended Aqua Line",
      "Both hubs are planned to feed the airport via RRTS / metro and dedicated link roads",
    ],
    benefit: "Mainline rail is the missing piece for out-of-NCR travellers and workforce - once Chola and Bodaki come online, the corridor stops depending on Delhi's stations.",
    stops: ["Chola Station", "Link road", "NIA"],
    paths: [[[850, 440], [740, 360], [640, 450]]],
    dashed: true,
  },
  {
    id: "isbt",
    mode: "ISBT & City Buses",
    icon: "Bus",
    status: "Announced",
    stat: "Sector 23C · 500 buses",
    headline: "An inter-state bus terminal at Sector 23C, minutes from the terminal",
    facts: [
      "YEIDA board approved the ISBT in Sector 23C (August 2026) to close the last-mile gap for buses from Delhi, Haryana, Rajasthan, Uttarakhand and UP districts",
      "City-bus fleet to expand from 100 to 500 buses linking industrial, commercial and residential sectors to the airport",
      "Airport's Ground Transportation Centre (GTC) consolidates buses, taxis, metro, Namo Bharat and PRT under one roof",
    ],
    benefit: "Buses are the first thing that actually arrives. A 500-bus network and a proper ISBT next door mean GYC residents and staff get daily airport access years before rail is complete.",
    stops: ["Delhi / Haryana / Rajasthan", "ISBT Sector 23C", "GTC at NIA"],
    paths: [[[740, 360], [640, 450]]],
  },
];

export const TRAVEL_ORIGIN = "Gaur Yamuna City (YEIDA Sector 19 / 22D)";

export const TRAVEL_TIMES = [
  {
    id: "nia",
    label: "Noida International Airport",
    today: { mode: "Car via Yamuna Expressway", time: "25 - 35 min" },
    future: { mode: "Pod Taxi / Namo Bharat from nearby stops", time: "10 - 15 min", enabledBy: "pod", status: "Proposed" },
    note: "Film City (Sector 21) to NIA is projected at ~8 minutes by PRT; RRTS stations in the YEIDA sectors sit within a short drive of GYC.",
  },
  {
    id: "delhi",
    label: "Delhi (Mayur Vihar / Sarai Kale Khan)",
    today: { mode: "Car via Noida Expressway + DND", time: "75 - 100 min" },
    future: { mode: "Yamuna Pushta Elevated Expressway", time: "45 - 60 min", enabledBy: "expressway", status: "Announced" },
    note: "Separately, a Delhi-NIA RRTS spur DPR targets ~21 minutes airport-to-Delhi; the Delhi-Varanasi bullet train would be faster still from the NIA underground station.",
  },
  {
    id: "ghaziabad",
    label: "Ghaziabad",
    today: { mode: "Car via Greater Noida / NH-9", time: "90 - 120 min" },
    future: { mode: "Namo Bharat RRTS (Ghaziabad-Jewar)", time: "40 - 55 min", enabledBy: "rrts", status: "Announced" },
    note: "NCRTC projects 35-50 minutes NIA-to-Ghaziabad; GYC-area stations are one or two stops short of the airport terminus.",
  },
  {
    id: "gnw",
    label: "Greater Noida West / Noida Sector 142",
    today: { mode: "Car via Yamuna Expressway + Pari Chowk", time: "50 - 70 min" },
    future: { mode: "RRTS local-metro services + Aqua Line", time: "30 - 40 min", enabledBy: "metro", status: "Under Development" },
    note: "Shared-track local metro between Ghaziabad and Ecotech VI plus Aqua Line extensions link GYC to Noida's metro grid.",
  },
  {
    id: "parichowk",
    label: "Pari Chowk, Greater Noida",
    today: { mode: "Car via Yamuna Expressway", time: "25 - 35 min" },
    future: { mode: "RRTS / Metro via Knowledge Park V", time: "15 - 20 min", enabledBy: "rrts", status: "Announced" },
    note: "Bodaki MMTH (rail + ISBT + metro) sits just beyond Pari Chowk on the same axis.",
  },
  {
    id: "faridabad",
    label: "Faridabad / Ballabhgarh",
    today: { mode: "Car via Delhi or Palwal", time: "90 - 120 min" },
    future: { mode: "Faridabad-Jewar Greenfield Expressway", time: "45 - 60 min", enabledBy: "expressway", status: "Under Development" },
    note: "31.42 km six-lane link from Ballabhgarh (Delhi-Mumbai Expressway) to Dayanatpur near NIA, targeted May 2027.",
  },
  {
    id: "agra",
    label: "Agra",
    today: { mode: "Car via Yamuna Expressway", time: "1 h 45 - 2 h 15" },
    future: { mode: "Delhi-Varanasi Bullet Train from NIA", time: "35 - 45 min", enabledBy: "bullet", status: "Announced" },
    note: "High-speed rail at up to 350 km/h from the underground NIA station; add the GYC-to-NIA leg.",
  },
];

export const MASTERPLAN_ZONES = [
  { id: "residential", label: "Residential", desc: "High-rise apartments and independent floors across GYC's park-facing sectors.", items: ["16th Parkview", "32nd Parkview", "Independent floors"] },
  { id: "plots", label: "Plots", desc: "Freehold residential plots in developed and developing sectors, including waterfront enclaves.", items: ["Waterfront Plots", "Sector 19 plots", "Park-facing plots"] },
  { id: "villas", label: "Villas", desc: "Premium independent living - lakeshore, heritage and contemporary villa clusters.", items: ["Lakeshore Villas", "Victorian Villas", "Shri Radhey Kunj"] },
  { id: "commercial", label: "Commercial", desc: "Shops, showrooms and commercial plots serving the township and corridor catchment.", items: ["City Galleria", "Commercial plots", "High-street retail"] },
  { id: "retail", label: "Retail", desc: "Daily-needs retail, high-street formats and the Aerocity Yamuna commercial vision.", items: ["Aerocity Yamuna", "Neighbourhood retail", "F&B formats"] },
  { id: "lifestyle", label: "Lifestyle", desc: "Green spaces, sports, schools, healthcare and community infrastructure inside GYC.", items: ["Central greens", "Sports infrastructure", "Schools & healthcare"] },
];

export const MARQUEE_ITEMS = [
  "GAUR YAMUNA CITY", "NOIDA INTERNATIONAL AIRPORT", "SECTOR 22D", "FILM CITY",
  "YAMUNA EXPRESSWAY", "YEIDA PLOT SCHEMES", "AEROCITY YAMUNA", "BUDDH INTERNATIONAL CIRCUIT",
  "MEDICAL DEVICE PARK", "DATA CENTRE PARK", "EASTERN PERIPHERAL EXPRESSWAY", "GREATER NOIDA",
];

export const SEVENTH_PARKVIEW = {
  rera: "UPRERAPRJ16087",
  priceRange: "Rs 1.36 Cr - Rs 1.88 Cr",
  stats: [
    { value: "34.61", label: "Acres, total site area" },
    { value: "954", label: "Total plots across the sector" },
    { value: "22.17", label: "Acres, plotted area" },
    { value: "3", label: "Guarded entry gates" },
  ],
  facts: [
    ["Total site area", "140,063.40 sq.m (34.61 acres)"],
    ["Plotted area", "89,750.17 sq.m (22.17 acres)"],
    ["Green area", "10,372.66 sq.m (2.56 acres) - yoga park, jogging track, kids' play area"],
    ["Road area", "39,326.80 sq.m (9.71 acres) across 9m and 12m wide interlocked internal roads"],
    ["Club plot", "600 sq.m - gymnasium, 14.6m x 3.6m swimming pool, indoor games, multipurpose hall"],
    ["Possession", "Ready to Move - commenced October 2023 (verify current status per plot)"],
  ],
  plotSizes: [
    { size: "88.20 sq.m (105 sq.yd)", count: "324 plots" },
    { size: "103.95 sq.m (124 sq.yd)", count: "36 plots" },
    { size: "120.68 sq.m (144 sq.yd)", count: "16 plots" },
    { size: "111.16 sq.m (133 sq.yd)", count: "2 plots" },
    { size: "143.50 sq.m (172 sq.yd)", count: "2 plots" },
    { size: "98.00 / 123.20 sq.m (117 / 147 sq.yd)", count: "1 plot each" },
  ],
  villaClusters: [
    { name: "Aero Villas", desc: "Premium plotted villas facing the international-standard cricket ground.", status: "Operational" },
    { name: "Sports Villas", desc: "Villa cluster set beside the GYC sports park and green belt.", status: "Under Development" },
    { name: "Shri Radhey Kunj", desc: "Residential villa plots near the 108-ft Lord Krishna statue and temple.", status: "Operational" },
  ],
  amenities: [
    "Clubhouse with gymnasium and swimming pool (14.6m x 3.6m, open deck)",
    "Indoor games - table tennis, pool table, chess and carom",
    "Multipurpose hall (approx. 1,350 sq.ft) with adjoining party lawn",
    "Dedicated yoga park and jogging / walking track",
    "Kids' play area with open gym equipment and seating",
    "3 guarded entry gates with granite-finished guard rooms",
    "9m and 12m wide interlocked internal roads with street lighting",
    "Adjacent to an international-standard cricket ground and sports park",
    "Near the 108-ft Lord Krishna statue and temple (under construction)",
  ],
};
